import { randomColor } from '../../../../helper/helper';
const COLORS = ["#00C49F", "#FFBB28", "#FF8042", "red", "pink","#0088FE" ];
const ProductChart = ({ data }) => {

    const render = () => {
        if (data && data.length) {
            return (
                <div style={{
                    display: "flex",
                    width: "100%",
                    height: "40px",
                    overflow: "hidden",
                    fontFamily: "sans-serif",
                    fontSize: "14px"
                }}>
                    {data.map((product, index) => (
                        <div
                            key={index}
                            style={{
                                flex: product.value,
                                backgroundColor: COLORS[index],
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                fontWeight: "bold",
                                color: "#333",
                            }}
                        >
                            <span style={{ fontWeight: 600 }}>{product.name}</span>&nbsp;
                            <span style={{ fontWeight: 400 }}>({product.value}%)</span>
                        </div>
                    ))}
                </div>
            );
        }
    }
    return render();
}

export default ProductChart;